//#region DevExtreme Imports

import DevExpress from 'devextreme'

//#endregion

import { IUserSession, TypeHelper, LocalizationHelper, CommonHelper } from "../../../helpers"
import { DashboardService } from "../dashboard.service"
import { Enums } from "../../../models/common"
import { OpProfile } from "../../../models/core"

export type DashboardDestinationLevelPopupOptions = {
    operatorId: number
    distributorId: number

    onSubmitCallback: (destination: DestinationLevelModel) => void
}

export type DestinationLevelModel = {
    destination: number
    id: number
}

export class DashboardDestinationLevelPopupController implements ng.IComponentController {
    private options: DashboardDestinationLevelPopupOptions

    private popupOptions: DevExpress.ui.dxPopupOptions
    private tabsOptions: DevExpress.ui.dxTabsOptions
    private selectDestinationLevelButtonOptions: DevExpress.ui.dxButtonOptions
    private cancelSelectionButtonOptions: DevExpress.ui.dxButtonOptions

    private selectedTab: string
    private onOperatorSelected: (valueId: number) => void
    private onDistributorSelected: (valueId: number) => void

    private operatorId: number
    private distributorId: number
    private selectedProfile: number

    private profilesList: OpProfile[]
    private profileSelectBoxOptions: DevExpress.ui.dxSelectBoxOptions

    private popup: DevExpress.ui.dxPopup
    private isLoading: boolean = false


    constructor(
        private $q: ng.IQService,
        private $timeout: ng.ITimeoutService,
        private userSession: IUserSession,
        private dashboardService: DashboardService
    ) { }

    //#region IComponentController Implementation
    public $onChanges(changes: { [index: string]: ng.IChangesObject<any> }): void {
        if (TypeHelper.isOptionsDefined(changes)) {
            this.initialize()
        }
    }
    //#endregion IComponentController Implementation End

    private initialize(): void {
        this.setOptions()
        this.showPopup()
    }

    private showPopup(): void {
        this.getPopup().then((popup: DevExpress.ui.dxPopup) => {
            popup.show().then(() => { })
        })
    }

    private setOptions(): void {
        this.tabsOptions = {
            dataSource: this.dashboardService.getDestinationLevelTabs(),
            keyExpr: 'key',
            selectedItemKeys: ['operator'],
            onItemRendered: (e: any) => {
                this.selectedTab = 'operator'
                const tabs: HTMLCollection = e.itemElement
                CommonHelper.setFocusOnTab(tabs)
            },
            onSelectionChanged: (e: any) => {
                const selectedItems: { text: string, key: string }[] = e.addedItems
                this.selectedTab = selectedItems != null && selectedItems.length > 0 ? selectedItems[0].key : null

                const tabs: HTMLCollection = e.element[0].children[0].children
                CommonHelper.setFocusOnTab(tabs)
            },
            onInitialized: (e: any) => { }
        }

        this.selectDestinationLevelButtonOptions = {
            text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Apply),
            height: 34,
            onInitialized: (e: any) => {

            },
            bindingOptions: {
                disabled: '$ctrl.isApplyButtonDisabled()'
            },
            onClick: (e: any) => {
                if (this.options.onSubmitCallback) {
                    const model: DestinationLevelModel = {
                        destination: this.getDestinationLevel(),
                        id: this.getDestinationObject()
                    }
                    
                    this.options.onSubmitCallback(model)
                }

                this.popup.hide()
            }
        }

        this.cancelSelectionButtonOptions = {
            text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Cancel),
            height: 34,
            onInitialized: (e: any) => {

            },
            onClick: () => {
                this.popup.hide()
            }
        }

        this.onOperatorSelected = (valueId: number): void => {
            this.operatorId = valueId
        }

        this.onDistributorSelected = (valueId: number): void => {
            this.distributorId = valueId
        }

        this.prepareProfiles()
    }

    private getPopup(): ng.IPromise<DevExpress.ui.dxPopup> {
        const deferred: ng.IDeferred<DevExpress.ui.dxPopup> = this.$q.defer<DevExpress.ui.dxPopup>()
        if (this.popup) {
            deferred.resolve(this.popup)
        } else {
            this.popupOptions = {
                title: LocalizationHelper.getLocalizedText('SelectLevel'),
                onInitialized: (e: any) => {
                    this.popup = e.component
                    deferred.resolve(this.popup)
                },
                maxWidth: 500,
                maxHeight: 400
            }
        }
        return deferred.promise
    }

    private prepareProfiles(): void {
        this.isLoading = true

        this.userSession.getDataProvider().System.getDictionaries([Enums.ReferenceType.IdProfile]).then(dictionaries => {
            if (dictionaries.containsKey(Enums.ReferenceType.IdProfile)) {
                this.profilesList = <OpProfile[]>dictionaries.tryGetValue(Enums.ReferenceType.IdProfile).values()
                this.profilesList = this.profilesList.filter(p => p.idModule == Enums.Module.WebSIMAX)
            } else {
                console.warn("Dictionaries for profiles not exist", Enums.ReferenceType.IdProfile)
                this.profilesList = []
            }

            this.profileSelectBoxOptions = null
            this.$timeout(() => {
                this.profileSelectBoxOptions = {
                    width: '100%',
                    noDataText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoData),
                    placeholder: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Select),
                    dataSource: this.profilesList,
                    valueExpr: 'idProfile',
                    displayExpr: 'name',
                    value: this.selectedProfile,
                    onValueChanged: (e: any) => {
                        this.selectedProfile = e.value
                    }
                }

                this.isLoading = false
            })
        })
    }

    private getDestinationLevel(): number {
        return (this.selectedTab == 'operator') ? CommonHelper.IdOperator : ((this.selectedTab == 'distributor') ? CommonHelper.IdDistributor : CommonHelper.IdProfile)
    }

    private getDestinationObject(): number {
        return (this.selectedTab == 'operator') ? this.operatorId : ((this.selectedTab == 'distributor') ? this.distributorId : this.selectedProfile)
    }

    private isApplyButtonDisabled(): boolean {
        if (this.selectedTab == 'operator')
            return !this.operatorId
        if (this.selectedTab == 'distributor')
            return !this.distributorId

        return !this.selectedProfile
    }
}